import { Urls } from "../Urls";

let networkDataPromise = null;
let networkDataCache = null;

export const prefetchNetworkData = () => {
    if (!networkDataPromise) {
        // Add cache busting parameter
        const urlWithCacheBuster = `${Urls.GlobalGridData}`;
        networkDataPromise = fetch(urlWithCacheBuster)
            .then(response => response.json())
            .then(data => {
                networkDataCache = data;
                return data;
            })
            .catch(error => {
                console.error("Failed to prefetch network data:", error);
                networkDataPromise = null; // Reset promise on failure so we can try again
                throw error;
            });
    }
    return networkDataPromise;
};

export const getNetworkData = () => {
    if (networkDataCache) {
        return Promise.resolve(networkDataCache);
    }
    if (networkDataPromise) {
        return networkDataPromise;
    }
    return prefetchNetworkData();
};
